import { useMutation as useReactMutation } from "@tanstack/react-query";
import { useCallback } from "react";
import { useDispatch } from "react-redux";

import { toast } from "Layout/slice";
import { parseErrorMessage } from "utils";

export const useMutation = ({
  mutationFn,
  onSuccess,
  onError,
  onSettled,
  // Set false when the caller surfaces the failure itself, otherwise the
  // default toast and the caller's own one both show up.
  showErrorToast = true,
}) => {
  const dispatch = useDispatch();

  const handleError = useCallback(
    (error) => {
      if (showErrorToast) {
        dispatch(
          toast({
            type: "error",
            body: parseErrorMessage(error),
          })
        );
      }

      if (onError) onError(error);
    },
    [dispatch, onError, showErrorToast]
  );

  const {
    mutate,
    mutateAsync,
    isPending,
    isLoading: isLoadingDeprecated,
    isError,
    isSuccess,
    data,
    error,
    reset,
  } = useReactMutation({
    mutationFn,
    onSuccess,
    onError: handleError,
    onSettled,
  });

  // Support both isPending (v4+) and isLoading (v3)
  const isLoading = isPending ?? isLoadingDeprecated ?? false;

  return {
    mutate,
    mutateAsync,
    isLoading,
    isPending,
    isError,
    isSuccess,
    data,
    error,
    reset,
  };
};
